import MediaModal from "./media-moda.component";

export default MediaModal;
